/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Amenity } from './Amenity';
import {
    AmenityFromJSON,
    AmenityFromJSONTyped,
    AmenityToJSON,
    AmenityToJSONTyped,
} from './Amenity';
import type { CabinCategoryGroup } from './CabinCategoryGroup';
import {
    CabinCategoryGroupFromJSON,
    CabinCategoryGroupFromJSONTyped,
    CabinCategoryGroupToJSON,
    CabinCategoryGroupToJSONTyped,
} from './CabinCategoryGroup';
import type { Pricing } from './Pricing';
import {
    PricingFromJSON,
    PricingFromJSONTyped,
    PricingToJSON,
    PricingToJSONTyped,
} from './Pricing';

/**
 * 
 * @export
 * @interface CompactCabinCategoryOffer
 */
export interface CompactCabinCategoryOffer {
    /**
     * Reference to a price model offer
     * @type {string}
     * @memberof CompactCabinCategoryOffer
     */
    priceModelCode: string;
    /**
     * 
     * @type {CabinCategoryGroup}
     * @memberof CompactCabinCategoryOffer
     */
    cabinCategoryGroup: CabinCategoryGroup;
    /**
     * 
     * @type {Pricing}
     * @memberof CompactCabinCategoryOffer
     */
    pricing: Pricing;
    /**
     * List of available amenities
     * @type {Array<Amenity>}
     * @memberof CompactCabinCategoryOffer
     */
    amenities?: Array<Amenity>;
}

/**
 * Check if a given object implements the CompactCabinCategoryOffer interface.
 */
export function instanceOfCompactCabinCategoryOffer(value: object): value is CompactCabinCategoryOffer {
    if (!('priceModelCode' in value) || value['priceModelCode'] === undefined) return false;
    if (!('cabinCategoryGroup' in value) || value['cabinCategoryGroup'] === undefined) return false;
    if (!('pricing' in value) || value['pricing'] === undefined) return false;
    return true;
}

export function CompactCabinCategoryOfferFromJSON(json: any): CompactCabinCategoryOffer {
    return CompactCabinCategoryOfferFromJSONTyped(json, false);
}

export function CompactCabinCategoryOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompactCabinCategoryOffer {
    if (json == null) {
        return json;
    }
    return {
        
        'priceModelCode': json['priceModelCode'],
        'cabinCategoryGroup': CabinCategoryGroupFromJSON(json['cabinCategoryGroup']),
        'pricing': PricingFromJSON(json['pricing']),
        'amenities': json['amenities'] == null ? undefined : ((json['amenities'] as Array<any>).map(AmenityFromJSON)),
    };
}

export function CompactCabinCategoryOfferToJSON(json: any): CompactCabinCategoryOffer {
    return CompactCabinCategoryOfferToJSONTyped(json, false);
}

export function CompactCabinCategoryOfferToJSONTyped(value?: CompactCabinCategoryOffer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceModelCode': value['priceModelCode'],
        'cabinCategoryGroup': CabinCategoryGroupToJSON(value['cabinCategoryGroup']),
        'pricing': PricingToJSON(value['pricing']),
        'amenities': value['amenities'] == null ? undefined : ((value['amenities'] as Array<any>).map(AmenityToJSON)),
    };
}

